import { createI18n } from 'vue-i18n';
import englishLocale from './locales/en.json';

export interface Language {
  code: string; // 'en' or 'en_US'
  locale: string; // 'en' or 'en_US'
  longName: string; // 'English'
  shortName: string; // 'En'
  numberFormat: string; // en_US
  dateFormat: string; // en_US
  dateFormatFull: string; // es_ES or pt
  distanceUnit: 'metric' | 'imperial';
  order: number;
  direction: 'rtl' | 'ltr';
}

export type LocaleMessage = string | LocaleMessages;

export interface LocaleMessages {
  [key: string]: LocaleMessage;
}

export function loadEnglishLocale(): LocaleMessages {
  const { locale, numberFormat, dateFormat, dateFormatFull, distanceUnit, longName, shortName, direction, order, ...messages } =
    englishLocale;
  return JSON.parse(JSON.stringify(messages)) as LocaleMessages;
}

const i18n = createI18n<LocaleMessages, string, true>({
  // Keep the legacy API while class-based components still use this.$t and this.$i18n.
  legacy: true,
  // A small number of existing components use useI18n() with the composition API.
  allowComposition: true,
  locale: 'en',
  fallbackLocale: 'en',
  messages: {
    en: loadEnglishLocale(),
  },
});

export default i18n;
